import { render, staticRenderFns } from "./device-infos.vue?vue&type=template&id=3ca8b950&scoped=true"
import script from "./device-infos.vue?vue&type=script&lang=js"
export * from "./device-infos.vue?vue&type=script&lang=js"
import style0 from "./device-infos.vue?vue&type=style&index=0&id=3ca8b950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca8b950",
  null
  
)

export default component.exports